import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

import * as d3 from 'd3';

import {ConnectionGraphService} from '../core/ecv-http-services/services/connection.graph.service';
import {LinkType} from '../enums/link-type.enum';
import {RankingModel} from '../ranking/ranking.model';
import {IdsModel} from './ids.model';
import {Ng4LoadingSpinnerService} from 'ng4-loading-spinner';


@Component({
  selector: 'app-connection-graph',
  templateUrl: './connection-graph.component.html'
})
export class ConnectionGraphComponent implements OnChanges {


  @Input() experts: RankingModel[];
  currentLinkType = null;
  idsModel: IdsModel;
  LinkType = LinkType;
  static svg;
  static width;
  static height;
  static simulation;

  constructor(private connectionGraphService: ConnectionGraphService,
              private spinnerService: Ng4LoadingSpinnerService) {
    this.idsModel = new IdsModel();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['experts']) {
      this.currentLinkType = null;
      this.destroyGraph();
      this.idsModel.ids = this.experts.map(x => x.id);
    }
  }

  getConnectionsInCompany() {
    this.currentLinkType = LinkType.COMPANY;
    this.spinnerService.show();
    this.connectionGraphService.getConnectionGraphInCompany(this.idsModel).subscribe(response => {
      this.spinnerService.hide();
      this.createGraph(response);
    }, error => {
      this.spinnerService.hide();
    });
  }

  getConnectionsInProject() {
    this.currentLinkType = LinkType.PROJECT;
    this.spinnerService.show();
    this.connectionGraphService.getConnectionGraphInProject(this.idsModel).subscribe(response => {
      this.spinnerService.hide();
      this.createGraph(response);
    }, error => {
      this.spinnerService.hide();
    });
  }

  destroyGraph() {
    ConnectionGraphComponent.svg = d3.select("svg");
    ConnectionGraphComponent.svg.selectAll('*').remove();
  }

  createGraph(model) {
    this.destroyGraph();
    ConnectionGraphComponent.width = +ConnectionGraphComponent.svg.attr("width");
    ConnectionGraphComponent.height = +ConnectionGraphComponent.svg.attr("height");
    if (this.isCurrentGraphCompaniesOrProjects()) {
      model.links = this.filterLinks(model.links);
    }
    ConnectionGraphComponent.simulation = d3.forceSimulation()
      .force("link", d3.forceLink().id((d) => {
        return d.id;
      }))
      .force("charge", d3.forceManyBody().strength(-15))
      .force("center", d3.forceCenter(ConnectionGraphComponent.width / 2, ConnectionGraphComponent.height / 2));

    let gnodes = ConnectionGraphComponent.svg.selectAll('g')
      .data(model.nodes)
      .enter()
      .append('g')
      .classed('gnode', true)
      .call(d3.drag()
        .on("start", this.dragstarted)
        .on("drag", this.dragged));

    let node = gnodes.append("circle")
      .attr("class", "node")
      .style('fill', () => 'rgb(62, 255, 172)')
      .style('cursor', () => 'pointer')
      .attr("r", 5);

    node.append("title")
      .text((d) => {
        return d.id;});

    gnodes.append("text")
      .text((d) => {
        return d.name;
      })
      .attr('dx', 12)
      .attr('dy', '.35em')
      .attr('font-size', 20)
      .style("fill", "#3b00f2")
      .style('cursor', () => 'pointer');

    let links = ConnectionGraphComponent.svg.append("g")
      .attr("class", "links")
      .style("stroke", "#3b00f2")
      .selectAll("line")
      .data(model.links)
      .enter();

    let link = links.append("line")
      .style("stroke-width", (d) => {
        return this.isCurrentGraphCompaniesOrProjects() ? d.strength : 1;
      });

    let label;
    if (this.isCurrentGraphCompaniesOrProjects()) {
      label = links.append("text")
        .text((d) => {
          return d.label;
        })
        .attr("font-size", 14)
        .attr('dx', 8)
        .style("font-family", "Roboto,Segoe UI Emoji")
        .style("stroke", "initial");
    }

    ConnectionGraphComponent.simulation
      .nodes(model.nodes)
      .on("tick", ticked);

    ConnectionGraphComponent.simulation.force("link")
      .links(model.links);

    function ticked() {
      link
          .attr("x1", (d) => {
            return d.source.x;
          })
          .attr("y1", (d) => {
            return d.source.y;
          })
          .attr("x2", (d) => {
            return d.target.x;
          })
          .attr("y2", (d) => {
            return d.target.y;
          });

      if (label) {
        label
          .attr("x", (d) => {
            return (d.source.x + d.target.x) / 2;
          })
          .attr("y", (d) => {
            return (d.source.y + d.target.y) / 2;
          });
      }

      gnodes.attr("transform", (d) => {
        return 'translate(' + [d.x, d.y] + ')';
      });
    }
  }

  dragstarted(d) {
    if (!d3.event.active) {
      ConnectionGraphComponent.simulation.alphaTarget(0.3).restart();
      setTimeout(() => {ConnectionGraphComponent.simulation.alphaTarget(0)}, 100);
    }
    d.fx = d.x;
    d.fy = d.y;
  }

  dragged(d) {
    var corners = document.getElementsByTagName("svg")[0].getBoundingClientRect();
    var width = corners.right - corners.left;
    var height = corners.bottom - corners.top;

    if (d3.event.x > 0 && d3.event.x < width) d.fx = d3.event.x;
    if (d3.event.y > 0 && d3.event.y < height) d.fy = d3.event.y;
  }

  filterLinks(links) {
    let filtered = [];
    links.forEach(link => {
      let index = filtered.findIndex(filter => filter.source === link.source && filter.target === link.target);
      if (index === -1) {
        filtered.push(link);
      } else {
        let foundedElem = filtered[index];
        foundedElem.strength++;
        foundedElem.label = foundedElem.label + ", " + link.label
      }
    });
    return filtered;
  }

  isCurrentGraphCompaniesOrProjects(): boolean {
    return this.currentLinkType === LinkType.COMPANY || this.currentLinkType === LinkType.PROJECT;
  }
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/graph/connection-graph.component.ts